// Author YuJiaBei
// Date 2020-10-04 06:46:06

import * as model from "@/model/sithMes/prd/SithMesPrdDispatchWorksModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdPpOperation(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
        backendEntity: "sithMesPrdPpOperation",
        selectRowsToItems: function (row) {
            return {value: row.id, text: row.operationSeq}
        },
    })
    .buildStore()
